import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ngx-eleui-lib',
  template: `
    <p>
      ngx-eleui-lib works!
    </p>
  `,
  styles: []
})
export class NgxEleuiLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
